import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

export const StyledTextField = styled(TextField)({
  '& .MuiInput-underline:after': {
    borderBottom: '1px solid #000',
  },
});
